module.exports = __webpack_public_path__ + "static/media/atomizadorDisco.92871412.png";